module.exports = __webpack_public_path__ + "static/media/60sMusicThumb.bcd18ec9.jpg";